/* Cart core: AJAX add/change with drawer + cart-page section re-rendering. Native forms remain the no-JS fallback. */
(function () {
  'use strict';
  if (window.__bbCartInitialized) return;
  window.__bbCartInitialized = true;

  const BB = window.BB;
  const routes = BB.config.routes;
  const DRAWER_SECTION = 'bb-cart-drawer';
  let viewSequence = 0;
  let pageViewId = null;
  let drawerViewId = null;
  const trackedViews = new Set();

  function track(event, properties) {
    try { BB.track(event, properties); } catch (e) {}
  }

  function cartSnapshot(cart) {
    if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0 ||
        !Number.isInteger(cart.total_price) || cart.total_price < 0 || !/^[A-Z]{3}$/.test(cart.currency || '')) return null;
    const items = [];
    for (const item of cart.items) {
      if (!item || typeof item.key !== 'string' || !item.key || item.key.length > 200 ||
          !/^\d{1,24}$/.test(String(item.product_id || '')) || !/^\d{1,24}$/.test(String(item.variant_id || '')) ||
          !Number.isInteger(item.quantity) || item.quantity < 1 || !Number.isInteger(item.final_price) || item.final_price < 0) return null;
      items.push({ key: item.key, product_id: String(item.product_id), variant_id: String(item.variant_id), quantity: item.quantity, final_price: item.final_price });
    }
    return { item_count: cart.item_count, total_price: cart.total_price, currency: cart.currency, items };
  }

  function readCartSnapshot(container) {
    const seed = container && container.querySelector('[data-bb-cart-analytics]');
    try { return seed ? cartSnapshot(JSON.parse(seed.textContent)) : null; } catch (e) { return null; }
  }

  function cartAnalyticsContext() {
    const drawer = document.getElementById('bb-cart-drawer');
    const page = pageSection();
    const surface = drawer && drawer.open ? 'drawer' : page ? 'page' : null;
    if (!surface) return null;
    const cart = readCartSnapshot(surface === 'drawer' ? drawer : page);
    if (!cart) return null;
    if (surface === 'drawer' && !drawerViewId) drawerViewId = 'drawer-' + (++viewSequence);
    if (surface === 'page' && !pageViewId) pageViewId = 'page-' + (++viewSequence);
    return { cart_surface: surface, cart_view_id: surface === 'drawer' ? drawerViewId : pageViewId, item_count: cart.item_count, value: cart.total_price / 100, currency: cart.currency };
  }

  function announceCartContext() {
    const context = cartAnalyticsContext();
    if (context && !trackedViews.has(context.cart_view_id)) {
      trackedViews.add(context.cart_view_id);
      track('bb_cart_viewed', context);
    }
    document.dispatchEvent(new CustomEvent('bb:analytics-context-ready'));
  }

  BB.getCartAnalyticsContext = cartAnalyticsContext;

  function ajaxUrl(route) {
    if (!route) return route;
    return /\.js(?:\?|$)/.test(route) ? route : route.replace(/\/$/, '') + '.js';
  }

  function pageSection() {
    return document.querySelector('[data-cart-page-section]');
  }

  function sectionIds() {
    const ids = [];
    if (document.querySelector('bb-cart-drawer')) ids.push(DRAWER_SECTION);
    const page = pageSection();
    if (page && page.dataset.cartPageSection) ids.push(page.dataset.cartPageSection);
    return ids;
  }

  function sectionParam() {
    return sectionIds().join(',');
  }

  function renderCartSections(sections) {
    if (!sections) return false;
    let drawerUpdated = false;

    const drawer = document.querySelector('bb-cart-drawer');
    if (drawer && sections[DRAWER_SECTION]) {
      const doc = new DOMParser().parseFromString(sections[DRAWER_SECTION], 'text/html');
      const body = doc.querySelector('[data-cart-drawer-body]');
      const footer = doc.querySelector('[data-cart-drawer-footer]');
      const count = doc.querySelector('[data-cart-drawer-count]');
      const currentBody = drawer.querySelector('[data-cart-drawer-body]');
      const currentFooter = drawer.querySelector('[data-cart-drawer-footer]');
      const currentCount = drawer.querySelector('[data-cart-drawer-count]');
      if (body && currentBody) {
        currentBody.innerHTML = body.innerHTML;
        drawerUpdated = true;
      }
      if (footer && currentFooter) {
        currentFooter.innerHTML = footer.innerHTML;
        currentFooter.hidden = footer.hidden;
      }
      if (count && currentCount) currentCount.innerHTML = count.innerHTML;
    }

    const currentPage = pageSection();
    const pageId = currentPage && currentPage.dataset.cartPageSection;
    if (currentPage && pageId && sections[pageId]) {
      const pendingNote = currentPage.querySelector('#cart-note')?.value;
      const doc = new DOMParser().parseFromString(sections[pageId], 'text/html');
      const fresh = doc.querySelector('[data-cart-page-section]');
      if (fresh) {
        currentPage.innerHTML = fresh.innerHTML;
        if (pendingNote !== undefined) {
          const nextNote = currentPage.querySelector('#cart-note');
          if (nextNote) nextNote.value = pendingNote;
        }
      }
    }
    return drawerUpdated;
  }

  function updateBadges(cart) {
    document.querySelectorAll('[data-bb-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach((el) => {
      el.textContent = BB.formatMoney(cart.total_price);
    });
  }

  function setLineBusy(line, busy) {
    if (!line) return;
    line.classList.toggle('is-updating', busy);
    line.setAttribute('aria-busy', String(busy));
    line.querySelectorAll('button, input').forEach((control) => {
      control.disabled = busy;
    });
  }

  function setFormError(form, message) {
    if (!form) return;
    const error = form.querySelector('[data-form-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function change(payload, lineEl) {
    const sections = sectionParam();
    const previous = readCartSnapshot(lineEl && lineEl.closest('bb-cart-drawer, [data-cart-page-section]'));
    const removed = previous && payload.quantity === 0 ? previous.items.find((item) => item.key === payload.id) : null;
    setLineBusy(lineEl, true);

    return BB.fetchJSON(ajaxUrl(routes.cartChange), {
      timeout: 10000,
      init: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign(sections ? { sections } : {}, payload))
      }
    })
      .then((cart) => {
        const next = removed && cartSnapshot(cart);
        if (next && next.currency === previous.currency && !next.items.some((item) => item.key === removed.key)) {
          const quantityForVariant = (items) => items.reduce((quantity, item) => quantity + (item.variant_id === removed.variant_id ? item.quantity : 0), 0);
          if (quantityForVariant(next.items) <= quantityForVariant(previous.items) - removed.quantity) {
            track('bb_cart_item_removed', { item_id: removed.product_id, variant_id: removed.variant_id, quantity: removed.quantity, price: removed.final_price / 100, price_basis: 'selected_variant', currency: previous.currency });
          }
        }
        renderCartSections(cart.sections);
        updateBadges(cart);
        document.dispatchEvent(new CustomEvent('bb:cart-updated', { detail: { cart } }));
        announceCartContext();
        return cart;
      })
      .catch((err) => {
        setLineBusy(lineEl, false);
        BB.toast((err.body && (err.body.description || err.body.message)) || BB.t('cartUpdateError'));
      });
  }

  function add(form, button) {
    if (!button) return Promise.resolve();
    const data = new FormData(form);
    // Shopify's successful add response can contain the new cumulative line quantity.
    const requestedQuantity = data.get('quantity') === null ? 1 : Number(data.get('quantity'));
    const sections = sectionParam();
    if (sections) data.append('sections', sections);

    setFormError(form, '');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    return BB.fetchJSON(ajaxUrl(routes.cartAdd), {
      timeout: 10000,
      init: { method: 'POST', body: data, headers: { Accept: 'application/json' } }
    })
      .then((body) => {
        const productId = String(body.product_id || '');
        const variantId = String(body.variant_id || body.id || '');
        if (/^\d{1,24}$/.test(productId) && /^\d{1,24}$/.test(variantId) &&
            variantId === String(data.get('id')) && Number.isInteger(requestedQuantity) && requestedQuantity > 0) {
          const properties = { item_id: productId, variant_id: variantId, item_name: body.product_title, quantity: requestedQuantity, currency: BB.config.currency };
          if (Number.isInteger(body.final_price) && body.final_price >= 0) {
            properties.price = body.final_price / 100;
            properties.price_basis = 'selected_variant';
          }
          track('add_to_cart', properties);
        }
        const drawerUpdated = renderCartSections(body.sections);
        announceCartContext();
        return BB.fetchJSON(ajaxUrl(routes.cart), { timeout: 10000 })
          .then((cart) => {
            updateBadges(cart);
            document.dispatchEvent(new CustomEvent('bb:cart-updated', { detail: { cart } }));
          })
          .catch(() => {
            const rendered = readCartSnapshot(document.getElementById('bb-cart-drawer')) || readCartSnapshot(pageSection());
            if (rendered) updateBadges(rendered);
          })
          .then(() => {
            const drawer = document.getElementById('bb-cart-drawer');
            if (drawer && drawerUpdated) {
              BB.openDialog(drawer);
            } else {
              const link = document.createElement('a');
              link.href = routes.cart;
              link.textContent = BB.t('viewCart');
              const wrap = document.createElement('span');
              wrap.textContent = BB.t('added') + ' ';
              wrap.appendChild(link);
              BB.toast(wrap);
            }
          });
      }, (err) => {
        const message = (err.body && (err.body.description || err.body.message)) || err.message || BB.t('error');
        setFormError(form, message);
        BB.toast(message);
      })
      .finally(() => {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  }

  document.addEventListener('bb:dialog:open', (e) => {
    if (e.target.id === 'bb-cart-drawer') announceCartContext();
  }, true);
  document.addEventListener('bb:dialog:close', (e) => {
    if (e.target.id === 'bb-cart-drawer') drawerViewId = null;
  }, true);

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-bb-cart-open]');
    if (open) {
      const dialog = document.getElementById('bb-cart-drawer');
      if (dialog) {
        e.preventDefault();
        BB.openDialog(dialog);
      }
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('.bb-cart-line');
      if (!line || line.getAttribute('aria-busy') === 'true') return;
      const input = line.querySelector('[data-cart-qty-input]');
      const current = parseInt(input && input.value ? input.value : '0', 10);
      const delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
      const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (Number.isFinite(delta) ? delta : 0));
      change({ id: line.getAttribute('data-key'), quantity: next }, line);
      return;
    }

    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      const line = remove.closest('.bb-cart-line');
      if (line && line.getAttribute('aria-busy') !== 'true') change({ id: line.getAttribute('data-key'), quantity: 0 }, line);
      return;
    }

    const checkout = e.target.closest('[data-bb-checkout]');
    if (checkout) BB.track('begin_checkout', { currency: BB.config.currency });
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    const line = input.closest('.bb-cart-line');
    if (!line || line.getAttribute('aria-busy') === 'true') return;
    const value = parseInt(input.value || '0', 10);
    change({ id: line.getAttribute('data-key'), quantity: Math.max(0, Number.isFinite(value) ? value : 0) }, line);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-bb-product-form]');
    if (!form) return;
    e.preventDefault();
    add(form, form.querySelector('[type="submit"]'));
  });

  class BBCartDrawer extends HTMLElement {}
  if (!customElements.get('bb-cart-drawer')) customElements.define('bb-cart-drawer', BBCartDrawer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', announceCartContext); else announceCartContext();
})();
